// Generated by GitHub Copilot
import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Adds withCredentials to every request so the CI4 session cookie is sent.
 * 401 handling is intentionally left to guards and components — intercepting
 * here causes redirect loops when auth-check calls themselves return 401.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req.clone({ withCredentials: true }));
  }
}
